<template>
    <kgr-children-data-provider :child-id="childId">
        <template #default="scope">
            <kgr-sidebar-box
                id="child:notes-general"
                :title="title(scope.data)"
            >
                <template #content>
                    <kgr-loading v-if="scope.loading" />
                    <textarea
                        v-if="!scope.loading"
                        ref="notesGeneral"
                        v-model="scope.data.notesGeneral"
                        class="kgr-input"
                        :class="{ 'highlight': isHighlighted, 'kgr-color--gray': isSaving }"
                        rows="5"
                        @blur="update(scope.data)"
                    ></textarea>
                </template>
            </kgr-sidebar-box>
        </template>
    </kgr-children-data-provider>
</template>

<script>
import ChildRepository from '../../../js/repository/ChildRepository';
import ChildrenDataProvider from '../../data-provider/ChildrenDataProvider';
import Loading from '../../common/Loading';
import SidebarBox from '../../sidebar/SidebarBox';

export default {
    components: {
        'kgr-children-data-provider': ChildrenDataProvider,
        'kgr-loading': Loading,
        'kgr-sidebar-box': SidebarBox,
    },
    props: {
        childId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            child: null,
            isHighlighted: false,
            isSaving: false,
        };
    },
    methods: {
        title(data) {
            return data ? this.$t('child.notes.general', { first_name: data.firstName }) : this.$t('child.notes.general_default');
        },
        update(child) {
            this.isSaving = true;
            ChildRepository
                .updateNotesGeneral(this.childId, child.notesGeneral)
                .then(() => {
                    this.isHighlighted = true;
                    setTimeout(() => {
                        this.isHighlighted = false;
                    }, 200);
                })
                .finally(() => {
                    this.isSaving = false;
                })
            ;
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
textarea {
    transition: background-color 1.5s ease-out;
}

.highlight {
    background-color: #4caf50;
    transition: background-color 0.15s ease-in;
}
</style>
